import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black border-t-2 border-copper mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {/* Brand */}
          <div className="flex flex-col items-center gap-4">
            <img 
              src="/images/COUP_logo2.png" 
              alt="COUP" 
              className="h-12 w-auto"
            />
            <p className="text-text-secondary text-sm leading-relaxed text-center" style={{ fontFamily: 'Courier Prime, monospace' }}>
              Literacy by any means necessary.<br />
              A tactical writing game where voice determines control.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display font-semibold text-white mb-4 uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-copper transition-colors" style={{ color: '#B8B5B0' }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-copper transition-colors" style={{ color: '#B8B5B0' }}>
                  Contact + Q&A
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-copper transition-colors" style={{ color: '#B8B5B0' }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/app/login" className="hover:text-copper transition-colors" style={{ color: '#B8B5B0' }}>
                  Launch Data Hub
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-display font-semibold text-white mb-4 uppercase tracking-wider">
              Connect
            </h3>
            <p className="text-text-secondary text-sm mb-2">
              Questions? Get in touch.
            </p>
            <Link 
              to="/contact"
              className="inline-block hover:text-copper transition-colors font-mono text-sm"
              style={{ color: '#C17A4A' }}
            >
              Contact Form →
            </Link>
          </div>
        </div>

        <div className="border-t-2 border-copper mt-6 pt-4"></div>

        {/* Bottom Bar */}
        <div className="text-center text-text-muted text-sm mt-4">
          <p>
            CounterScriptHQ is published and operated by{' '}
            <span className="text-text-secondary font-semibold">DreadKnot Juice Press LLC</span> - Education. Unfiltered.
          </p>
          <p className="mt-1">
            © {new Date().getFullYear()} CounterScriptHQ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
